import errorResponseHandler from '@data/helpers/errorResponseHandler';
import authAxios from '@services/authAxios';

const fetchCustomerList = async (search = {}) => {
    const { group, customer } = search;

    const params = new URLSearchParams({});

    if (group) params.append('group', group);
    if (customer) params.append('search', customer);

    try {
        const { data } = await authAxios({
            method: 'GET',
            url: `/api/v1/master-data/customer-list?${params.toString()}`,
        });

        return data;
    } catch (error) {
        throw new Error(errorResponseHandler(error));
    }
};

export default fetchCustomerList;
